export const INPUTS = {
  login: [
    {
      id: 'email',
      type: 'text',
      label: 'Correo electrónico',
      name: 'email'
    },
    {
      id: 'password',
      type: 'password',
      label: 'Contraseña',
      name: 'password'
    }
  ],
  register: [
    {
      id: 'name',
      type: 'text',
      label: 'Nombre',
      name: 'name'
    },
    {
      id: 'surnames',
      type: 'text',
      label: 'Apellidos',
      name: 'surnames'
    },
    {
      id: 'email',
      type: 'text',
      label: 'Email',
      name: 'email'
    },
    {
      id: 'password',
      type: 'password',
      label: 'Contraseña',
      name: 'password',
      minLength: {
        value: 10,
        message: 'La contraseña debe tener al menos 10 caracteres'
      },
      description: 'La contraseña debe tener al menos 10 caracteres, una mayúscula, una minúscula, un número y un caracter especial'
    },
    {
      id: 'password_confirmation',
      type: 'password',
      label: 'Repite la contraseña',
      name: 'password_confirmation',
      minLength: {
        value: 10,
        message: 'La contraseña debe tener al menos 10 caracteres'
      },
      validate: 'password_confirmation'
    }
  ]
}
